import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
/**
 * Rules Fetch Policy
 *
 * Responsibilities:
 * - Fetch rule definitions on init
 * - Fetch applied rules for the account on init
 * - Dispatch data commands with fetched data
 * - Handle loading states
 */
export const createRulesFetchPolicy = (
  backend: ClientLibraryType,
  accountId: string
): Policy<AccountState, AccountCommand> => ({
  name: 'rules-fetch',

  init: ({ dispatch }) => {
    console.log( '[account] Initializing rules fetch policy' );

    // Use IIFE for async work inside sync init
    ( async () => {
      // Fetch definitions
      dispatch(
        { type: 'account/rules/loading/setDefinitions', payload: { isLoading: true }},
        { source: 'api' }
      );

      try {
        const defsResponse = await backend.queries.RuleDefinitions();
        if ( defsResponse && defsResponse.length ) {
          dispatch(
            { type: 'account/rules/definitions/set', payload: { definitions: defsResponse }},
            { source: 'api' }
          );
        }
      } catch ( error ) {
        console.error( '[account] Rules definitions fetch error:', error );
      } finally {
        dispatch(
          { type: 'account/rules/loading/setDefinitions', payload: { isLoading: false }},
          { source: 'api' }
        );
      }

      // Fetch applied rules
      dispatch(
        { type: 'account/rules/loading/setAppliedRules', payload: { isLoading: true }},
        { source: 'api' }
      );

      try {
        const rulesResponse = await backend.queries.Rules({
          filter: [{ field: 'hierarchyEntityIds', op: 'contains', value: accountId }]
        });
        if ( rulesResponse && rulesResponse.length ) {
          dispatch(
            { type: 'account/rules/applied/set', payload: { rules: rulesResponse }},
            { source: 'api' }
          );
        }
      } catch ( error ) {
        console.error( '[account] Applied rules fetch error:', error );
      } finally {
        dispatch(
          { type: 'account/rules/loading/setAppliedRules', payload: { isLoading: false }},
          { source: 'api' }
        );
      }
    })();

    // No cleanup needed for one-time fetch
    return undefined;
  }
});
